/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col, Image, Space, Upload, Modal } from "antd";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { NavLink } from "react-router-dom";
import { ListTable, LinkProduct } from "./ListTable";
import { Menu } from "./Menu";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Button, TextField, Box, Typography, FormControlLabel, Switch, Checkbox } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import gstActions from "../../../../Admin/Setup/redux/actions";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import objectScan from 'object-scan';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission } from '../../../../../helpers/utilities';
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import DeleteModal from "../../../../Shared/components/DeleteModal";

const Catalogue = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const [visible, setVisible] = useState(false);
    const [viewVisible, setViewVisible] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { productGstdetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { catalogueDetails, categoryDetails, loader, productDetails, brandDetails } = useSelector(state => state.younoteAdminProductReducer);
    const { createDetails, createError, createLoader, createData, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);

    const [catalogueList, setCatalogueList] = useState([]);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [deleteAllModal, setDeleteAllModal] = useState(false);
    const [activeId, setActiveId] = useState('');
    const [loadingAPI, setLoadingAPI] = useState('catalogue');
    const [catLevel, setCatLevel] = useState(0);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorBrand, setErrorBrand] = useState(false);
    const [errorPrefix, setErrorPrefix] = useState(false);

    const [errorCatalogueId, setErrorCatalogueId] = useState(false);
    const [selected, setSelected] = useState([]);

    const [catalogueId, setCatalogueId] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [categoryEditId, setCategoryEditId] = useState('');
    const [catalogueEditId, setCatalogueEditId] = useState('');

    const [commonData, setCommonData] = useState({});
    const [type, setType] = useState('');
    const [commonError, setCommonError] = useState(false);
    const [viewData, setViewData] = useState('catalogue');
    const [categoryList, setCategoryList] = useState([]);
    const [categoryListMain, setCategoryListMain] = useState([]);
    const [categoryListView, setCategoryListView] = useState(false);
    const [viewDataLoader, setViewDataLoader] = useState(false);
    const [multiples, setMultiples] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const [importVisible, setImportVisible] = useState(false);
    const { history } = props;

    const dispatch = useDispatch();

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const handleViewClose = () => {
        setViewVisible(false);
        stateEmpty();
        stateEmptyInput();
    }

    const handleViewOpen = () => {
        setViewVisible(true);
        stateEmpty();
        setCategoryEditId('');
        setCatalogueEditId('');
        if (categoryId && categoryId !== '') {
            let a = categoryList && categoryList.filter((el) => { return el.id === categoryId });
            if (a && a?.length !== 0) {
                setCategoryForm({ catalogueId: a[0]?.catalogueId, parentId: categoryId, categoryPrefix: 'L' + (a[0]?.level + 1) + '-' });
            }
        } else {
            setCategoryForm({ catalogueId: catalogueId, parentId: categoryId, categoryPrefix: 'L1-' });
        }
    };

    const [form, setForm] = useState({
        catalogueName: "",
        cataloguePrefix: ""
    });

    const [categoryForm, setCategoryForm] = useState({});

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const catagoryChangeHandler = (e, field = '') => {
        if (field !== '') {
            if (field === 'hsnId') {
                let a = hsnDetails?.length > 0 && hsnDetails.filter(function (el) { return el.id === e.id });
                if (a && a?.length !== 0) {
                    setCategoryForm({
                        ...categoryForm,
                        [field]: e.id,
                        'productGstId': a[0].productGstId
                    });
                } else {
                    setCategoryForm({
                        ...categoryForm,
                        [field]: ''
                    });
                }
            } else if (field === 'parentId') {
                setCategoryForm({
                    ...categoryForm,
                    [field]: e.id,
                    'level': e.level + 1
                });
            } else if (field === 'brandId') {
                let a = brandDetails?.length > 0 && brandDetails.filter(function (el) { return el.id === e.id });
                setCategoryForm({
                    ...categoryForm,
                    [field]: e.id,
                    'categoryName': a[0]?.brandName
                });
            } else {
                setCategoryForm({
                    ...categoryForm,
                    [field]: e !== '' ? e.id : e,
                });
            }
        } else {
            setCategoryForm({
                ...categoryForm,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if ((prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) || (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails)) {
            toast.dismiss();
            toast(createDetails || editDetails);
            loadingNewData();
            setVisible(false);
            setViewVisible(false);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setCommonError(error);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setCommonError(error);
        }
    }, [createDetails, createError, editDetails, editError]);

    const loadingNewData = () => {
        if (loadingAPI === 'catalogue') {
            dispatchFilter();
            setViewData('catalogue');
        } else if (loadingAPI === 'product') {
            setViewData('product');
            dispatch({
                type: actions.PRODUCT_DETAILS_START,
                filter: {
                    where: { ["and"]: [{ categoryId: categoryId }] }
                }
            });
        } else {
            setViewData('category');
            if (createData?.parentId || commonData?.parentId) {
                dispatch({
                    type: actions.CATEGORY_DETAILS_START,
                    url: 'product-categories',
                    filter: {
                        where: { ["and"]: [{ parentId: createData.parentId || commonData.parentId }] }
                    }
                });
            } else {
                dispatch({
                    type: actions.CATEGORY_DETAILS_START,
                    url: 'product-categories',
                    filter: {
                        where: { ["and"]: [{ catalogueId: createData.catalogueId || commonData.catalogueId }, { parentId: null }] }
                    }
                });
            }
            setCategoryListView(true);
            setTimeout(() => {
                dispatch({
                    type: actions.CATEGORY_DETAILS_START,
                    url: 'product-categories',
                });
                setCategoryListView(false);
            }, 500)
        }
        setMultiples(false);
        setDeleteAllModal(false);
        setSelected([]);
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Catalogue', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);


    useEffect(() => {
        setMultiples(false);
        setSelected([]);
        if (categoryDetails?.length > 0) {
            if (!categoryListView) {
                setCategoryList(categoryDetails);
            } else {
                let index = catalogueList.findIndex((d, i) => catalogueId === d.id);
                if (catalogueList?.length > 0) {
                    if (type === 'catalogue') {
                        if (index >= 0) {
                            catalogueList[index].submenu = categoryDetails;
                            catalogueList[index].hasSubCategories = true;
                        }
                    } else if (type === 'category') {
                        if (getNodeWithParents(catalogueList, categoryId)) {
                            let a = getNodeWithParents(catalogueList, categoryId);
                            if (a?.categoryName) {
                                getNodeWithParents(catalogueList, categoryId).submenu = categoryDetails;
                                getNodeWithParents(catalogueList, categoryId).hasSubCategories = true;
                            } else {
                                getNodeWithParentsEx(catalogueList, categoryId).submenu = categoryDetails;
                                getNodeWithParentsEx(catalogueList, categoryId).hasSubCategories = true;
                            }
                        }
                    }
                    setCategoryListMain(categoryDetails);
                }
            }
        }
        if (categoryListView) {
            setTimeout(() => {
                setViewDataLoader(true);
            }, 200)
        }
    }, [categoryDetails]);

    const getNodeWithParents = (data, id) => objectScan(['**(^submenu$).id'], {
        useArraySelector: false,
        abort: true,
        rtn: 'parent',
        filterFn: ({ value }) => value === id
    })(data);

    const getNodeWithParentsEx = (data, id) => objectScan(['(^submenu$).id'], {
        useArraySelector: false,
        abort: true,
        rtn: 'parent',
        filterFn: ({ value }) => parseInt(value) === parseInt(id)
    })(data);


    useEffect(() => {
        setTimeout(() => {
            setViewDataLoader(true);
        }, 200)
    }, [productDetails]);

    useEffect(() => {
        setViewDataLoader(true);
        setCatalogueList(getList)
    }, [getList]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'catalogues',
            skip: skip,
            filter: {
                limit: limit,
                skip: skip,
                // order: sortBy + ' ' + sortOrder,
            }
        });
        dispatch({
            type: actions.CATALOGUE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
    }

    const hsnApi = (search = '') => {
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'id desc',
                limit: 500,
                skip: 0
            },
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter();
        hsnApi('');
        dispatch({
            type: actions.CATEGORY_DETAILS_START, url: 'product-categories', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.BRAND_DETAILS_START, url: 'brands', filter: {
                order: 'id  desc'
            }
        });
    });

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(s);
    }

    const createCatalogue = (e) => {
        e.preventDefault();
        let emptyCatelogueName = emptyValidation('Name', form.catalogueName);
        //let emptyCateloguePrefix = emptyValidation('Prefix', form.cataloguePrefix);
        emptyState();
        if (emptyCatelogueName.isValid) {
            setLoadingAPI('catalogue');
            dispatch({
                type: catalogueEditId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'catalogues',
                title: 'Catalogue',
                id: catalogueEditId,
                details: form
            });
        } else {
            if (emptyCatelogueName.errors) {
                setErrorName(emptyCatelogueName.errors);
            }
        }
    }

    const emptyStateInput = () => {
        setCatalogueEditId('');
        setForm({
            catalogueName: "",
            cataloguePrefix: ""
        });
    };

    const emptyState = () => {
        setErrorName(false);
        setErrorPrefix(false);
        setCommonError(false);
        setErrorBrand(false);
    };

    const handleAddMore = (e) => {
        createCatalogue(e);
    }

    const createCategory = (e) => {
        e.preventDefault();
        let emptyCategoryName = emptyValidation('Category Name', categoryForm.categoryName);
        let emptyCatalogueId = emptyValidation('Catalogue', categoryForm.catalogueId, 'dropDown');
        let nameCheck = true;
        // if (categoryEditId === '') {
        //     let a = categoryDetails.length > 0 && categoryDetails?.filter((el) => { return el.categoryName === categoryForm.categoryName });
        //     if (a && a?.length > 0) {
        //         nameCheck = false;
        //     }
        // }
        stateEmpty();
        if (emptyCategoryName.isValid && emptyCatalogueId.isValid && nameCheck) {
            setCategoryListView(true);
            if (!categoryForm.isBrand) {
                categoryForm.brandId = '';
            }
            let data = Object.fromEntries(Object.entries(categoryForm).filter(([_, v]) => v !== null && v !== ''));
            setLoadingAPI('category');
            let checkBrand = true;
            if (data?.parentId) {
                let a = customObject(categoryList, data?.parentId);
                data.level = a.level + 1;
                if (a.rootCategoryId) {
                    data.rootCategoryId = a.rootCategoryId;
                    if (a && a?.brandId) {
                        form.brandId = a?.brandId;
                    }
                }

                if (a?.brandId) {
                    if (data?.brandId && a?.brandId !== data.brandId) {
                        checkBrand = false;
                    } else {
                        data.brandId = a?.brandId;
                    }
                }
            } else {
                data.level = 1;
            }

            if (checkBrand) {
                dispatch({
                    type: categoryEditId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                    url: 'product-categories',
                    title: 'Categories',
                    method: 'put',
                    id: categoryEditId,
                    details: data
                });
            } else {
                setErrorBrand('Brand Not equal to parent Brand');
            }


        } else {
            if (emptyCategoryName.errors) {
                setErrorName(emptyCategoryName.errors);
            }
            // if (!nameCheck) {
            //     setErrorName('Name already exits');
            // }
            if (emptyCatalogueId.errors) {
                setErrorCatalogueId(emptyCatalogueId.errors);
            }
        }
    }

    const stateEmptyInput = () => {
        setCategoryEditId('');
        setCatalogueEditId('');
        setCategoryForm({ catalogueId: catalogueId, parentId: categoryId });
    };

    const stateEmpty = () => {
        setErrorName(false);
        setErrorPrefix(false);
        setErrorCatalogueId(false);
        setCommonError(false);
        setErrorBrand(false);
    };

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleParentClick = (type, data) => {
        setType(type);
        let filter = '';
        if (type === 'catalogue') {
            setCatalogueId(data.id);
            setCategoryId('');
            filter = { ["and"]: [{ catalogueId: data.id }, { parentId: null }] };
        } else {
            setCategoryId(data.id);
            filter = { ["and"]: [{ parentId: data.id }] };
            catagoryChangeHandler(data, 'parentId');
        }
        setActiveId(`${type}_${data.id}`);
        setViewDataLoader(false);
        if (data.hasCategories || data.hasSubCategories) {
            setViewData('category');
            dispatch({
                type: actions.CATEGORY_DETAILS_START,
                url: 'product-categories',
                filter: {
                    where: filter
                }
            });
        } else {
            setViewData('product');
            if (data.catalogueName) {
                filter = { ["and"]: [{ catalogueId: data.id }] };
            } else {
                filter = { ["and"]: [{ categoryId: data.id }] };
            }

            dispatch({
                type: actions.PRODUCT_DETAILS_START,
                filter: {
                    where: filter
                }
            });
        }
        setCatLevel(data?.level);
        setCategoryListView(true);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.CATALOGUE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'catalogues'
        });
    }

    const handleClickViewData = (type, data) => {
        const element = document.getElementById(`${type}_${data.id}`);
        if (element !== null && !element.checked) {
            element.click();
        }
    }

    const handleClickProducts = () => {
        setViewData('link-products');
        let filter = { ["and"]: [{ categoryId: null }] };
        dispatch({
            type: actions.PRODUCT_DETAILS_START,
            filter: {
                where: filter
            }
        });
    }

    const handleLinkedProducts = (selected) => {
        setLoadingAPI('product');
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: 'update-category',
            title: 'Linked Products',
            details: { "productIdList": selected, "categoryId": categoryId }
        });
    }

    const handleClickEditData = (type, data) => {
        setCommonData(data);
        if (type === 'category') {
            handleViewOpen();
            setCategoryEditId(data?.id);
            setCategoryForm({
                "catalogueId": data?.catalogueId || '',
                "categoryName": data?.categoryName || '',
                "categoryPrefix": data?.categoryPrefix || '',
                "hsnId": data?.hsnId,
                "isBrand": data?.isBrand,
                "brandId": data?.brandId,
                "parentId": data?.parentId || '',
                "productGstId": data?.productGstId || '',
            });
        } else if (type === 'catalogue') {
            handleOpen();
            setCatalogueEditId(data?.id);
            setForm({
                "catalogueName": data?.catalogueName,
                "cataloguePrefix": data?.cataloguePrefix,
            });
        }
    }

    const handleClickDeleteData = (type, data) => {
        setCategoryEditId(data?.id);
        setCatalogueEditId(data?.id);
        setLoadingAPI(type);
        setCommonData(data);
        setDeleteModal(type);
    }

    const handleDeleteIds = () => {
        dispatch({
            type: crudActions.DELETE_DETAILS_START,
            url: '/product-categories/deleteByIds',
            title: viewData,
            details: selected,
            action: viewData
        });
        let id = selected?.length && selected[0];
        if (viewData === 'category') {
            // categoryListMain?.length && categoryListMain.filter((el) => { return el.id === id });
            setLoadingAPI(viewData);
            setCommonData(...categoryListMain.filter((el) => { return el.id === id }));
        }
    }

    const handleRowClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;



    const handleSelectAll = () => {
        setMultiples(true);
        let ids = [];
        if (viewData === 'catalogue') {
            getList?.length > 0 && getList?.map((d, i) => {
                ids.push(d?.id);
            });
        } else {
            categoryListMain?.length > 0 && categoryListMain?.map((d, i) => {
                ids.push(d?.id);
            });
        }
        setSelected(ids);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Catalogue', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.paddingZero)}>
                <PrimaryCard
                    title={'Catalogue'}
                    component={
                        <Row className={classes.fullHeight}>
                            <Col xxl={5} xl={5} lg={6} md={7} sm={8} xs={11} className={classes.leftScroll}>

                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.textAlignRight, classes.padding20, classes.customStickyTop, classes.bgWhite)}>
                                    <Space direction="horizontal" align="center" className={classes.DisplayBlock} size={[10, 10]}>
                                        <NavLink
                                            title={"All Catalogue"}
                                            to={"#"}
                                            onClick={() => { setLoadingAPI('catalogue'); loadingNewData(); }}
                                            className={clsx(classes.customLink)}>
                                            <Image
                                                src={ViewIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            /> <span className={clsx(classes.addLink, classes.noneImage, classes.color, classes.bold)}>All Catalogue</span>
                                        </NavLink>
                                        <NavLink
                                            to={"#"}
                                            title={"Add Catalogue"}
                                            onClick={() => handleOpen()}
                                            className={clsx(classes.customLink)}>
                                            <Image
                                                src={AddIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            /> <span className={clsx(classes.addLink, classes.noneImage, classes.color, classes.bold)}>Add Catalogue</span>
                                        </NavLink>
                                    </Space>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.sideBarMenu)}>
                                    <Menu
                                        handleParentClick={(type, data) => handleParentClick(type, data)}
                                        details={catalogueList}
                                        loadMore={loadMore}
                                        loadMoreContent={loadMoreContent}
                                        loadMoreTask={() => loadMoreTask()}
                                        handleOpen={() => handleOpen()}
                                        activeId={activeId}
                                        type={type} />
                                </Col>
                            </Col>
                            <Col xxl={19} xl={19} lg={18} md={17} sm={16} xs={13} className={clsx(classes.padding20, { [classes.catalogueDelete]: multiples && selected?.length > 0 })}>
                                <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.textAlignRight)}>
                                        <Space direction="horizontal" align="center" className={classes.leftScrollCatalogue}>
                                            {/* {
                                                multiples ? <>
                                                    {
                                                        <>
                                                            {
                                                                ((viewData === 'catalogue' && selected?.length !== getList?.length) || (viewData === 'category' && selected?.length !== categoryListMain?.length)) && <NavLink
                                                                    to={`#`}
                                                                    onClick={() => handleSelectAll()}
                                                                    className={clsx(classes.customLink)}>
                                                                    <Image
                                                                        src={SelctMultiples}
                                                                        preview={false}
                                                                        className={clsx(classes.antImage)}
                                                                    /> <span className={clsx(classes.addLink, classes.color, classes.margin20r, classes.bold)}>Select All</span>
                                                                </NavLink>
                                                            }
                                                        </>
                                                    }
                                                    {
                                                        selected?.length > 0 && <NavLink className={clsx(classes.deleteBtn)} to={'#'} onClick={() => handleDeleteIds()}>
                                                            {deleteText()}
                                                        </NavLink>
                                                    }
                                                </> : <NavLink
                                                    to={`#`}
                                                    onClick={() => setMultiples(!multiples)}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={SelctMultiples}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.margin20r, classes.bold)}>Select Multiple</span>
                                                </NavLink>
                                            } */}
                                            {
                                                ((viewData === 'catalogue' && selected?.length !== getList?.length) || (viewData === 'category' && selected?.length !== categoryListMain?.length)) && <NavLink
                                                    to={`#`}
                                                    onClick={() => handleSelectAll()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={DeleteIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.noneImage, classes.color, classes.bold)}>Delete All</span>
                                                </NavLink>
                                            }
                                            {
                                                viewData === 'product' && <NavLink to={"#"} onClick={() => handleClickProducts()}
                                                    className={clsx(classes.customLink, { [classes.disabled]: type !== 'category' })}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.noneImage, classes.color, classes.bold)}>Link Products</span>
                                                </NavLink>
                                            }

                                            {
                                                (productDetails === '' || productDetails?.length === 0 || viewData !== 'product') && viewData !== 'link-products' &&
                                                <NavLink to={"#"} onClick={() => {
                                                    if (catLevel !== 4) { handleViewOpen() }
                                                }}
                                                    className={clsx(classes.customLink, { [classes.disabled]: catLevel === 4 })}>
                                                    <Image

                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.noneImage, classes.color, classes.bold)}>Add Category</span>
                                                </NavLink>
                                            }

                                            {/* <NavLink
                                                to="#"
                                                onClick={() => { loadImportExportData('ProductCategories'); }}
                                                className={clsx(classes.margin20r, classes.customLink)}>
                                                <Image
                                                    src={ExportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                            </NavLink>
                                            <NavLink
                                                to="#"
                                                onClick={() => { setImportVisible(true); }}
                                                className={clsx(classes.margin20r, classes.customLink)}>
                                                <Image
                                                    src={ImportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                            </NavLink> */}
                                        </Space>
                                    </Col>
                                </Row>
                                <div className={clsx(classes.catalogue)}>
                                    <div className={clsx(classes.row)}>
                                        {
                                            viewDataLoader ? <>
                                                {
                                                    viewData === 'catalogue' &&
                                                    <>
                                                        {
                                                            getList?.length > 0 ? getList.map((cataItem, key) =>
                                                                <div key={key} className={clsx(classes.colInlineCat, classes.margin20t)}>
                                                                    <div className={clsx(classes.categoryListLink)}>
                                                                        <NavLink title={cataItem.catalogueName} to="#" onClick={() => handleClickViewData('catalogue', cataItem)}>
                                                                            <div className={clsx(classes.catalogueTitle)}>{cataItem.catalogueName}</div>
                                                                            <div className={clsx(classes.catalogueDesign)}>
                                                                                <div className={clsx(classes.catalogueDesign2)}></div>
                                                                            </div>
                                                                        </NavLink>
                                                                        <Space direction="horizontal" align="center" size={[15, 15]} className={classes.categoryListActionIcons}>
                                                                            <NavLink to="#" className={classes.editIcon} onClick={() => handleClickEditData('catalogue', cataItem)}>
                                                                                <Image src={EditIcon} preview={false} />
                                                                            </NavLink>
                                                                            <NavLink to="#" className={classes.editIcon} onClick={() => handleClickDeleteData('catalogue', cataItem)}>
                                                                                <Image src={DeleteIcon} preview={false} />
                                                                            </NavLink>
                                                                        </Space>
                                                                    </div>
                                                                </div>
                                                            ) : <div className={classes.textAlignCenter}>No Category Available</div>
                                                        }
                                                    </>
                                                }
                                                {
                                                    viewData === 'category' &&
                                                    <>
                                                        {
                                                            categoryListMain?.length > 0 ? categoryListMain.map((catItem, key) =>
                                                                <div key={key} className={clsx(classes.colInlineCat, classes.margin20t)}>
                                                                    <div className={clsx(classes.categoryListLink)}>
                                                                        {
                                                                            multiples && <Checkbox onClick={() => handleRowClick(catItem.id)} color="primary" checked={isSelected(catItem.id)} />
                                                                        }
                                                                        <NavLink title={catItem.categoryName} to="#" onClick={() => handleClickViewData('category', catItem)}>
                                                                            <div className={clsx(classes.catalogueTitle)}><div title={catItem?.categoryName}>{catItem?.categoryName}</div>
                                                                                <div className={classes.categoryPrefix} title={catItem?.categoryPrefix ? '(' + catItem?.categoryPrefix + ')' : ''}>{catItem?.categoryPrefix ? '(' + catItem?.categoryPrefix + ')' : ''}</div></div>
                                                                            <div className={clsx(classes.catalogueDesign)}>
                                                                                <div className={clsx(classes.catalogueDesign2)}></div>
                                                                            </div>
                                                                        </NavLink>
                                                                        <Space direction="horizontal" align="center" size={[15, 15]} className={classes.categoryListActionIcons}>
                                                                            <NavLink to="#" className={classes.editIcon} onClick={() => handleClickEditData('category', catItem)}>
                                                                                <Image src={EditIcon} preview={false} />
                                                                            </NavLink>
                                                                            <NavLink to="#" onClick={() => handleClickDeleteData('category', catItem)}>
                                                                                <Image
                                                                                    src={DeleteIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                        </Space>
                                                                    </div>
                                                                </div>
                                                            ) : <div className={classes.textAlignCenter}>No Category Available</div>
                                                        }
                                                    </>
                                                }
                                                {
                                                    viewData === 'product' && <div className={clsx(classes.colInlineProduct)}>
                                                        <ListTable categoryDetails={categoryList} categoryId={categoryId} handleLoadingApi={(data) => setLoadingAPI(data)} details={productDetails} /></div>
                                                }
                                                {
                                                    viewData === 'link-products' && <div className={clsx(classes.colInlineProduct)}>
                                                        <LinkProduct handleLinkedProducts={(selected) => handleLinkedProducts(selected)} details={productDetails} /></div>
                                                }
                                            </> : <div className={classes.loadMoreCircle}></div>
                                        }

                                    </div>
                                </div>
                                {
                                    multiples && (selected?.length > 0 &&
                                        <Row className={classes.notificationButtons}>
                                            <Col span={24} className={classes.textAlignRight}>
                                                <Space direction="horizontal" align="center">
                                                    <NavLink className={clsx(classes.AddMoreBtn)} to={'#'} onClick={() => { setSelected([]); }}>
                                                        Clear All</NavLink>
                                                    <NavLink className={clsx(classes.deleteBtn)} to={'#'} onClick={() => { setDeleteAllModal(true); }}>
                                                        {`Delete (${selected?.length})`}</NavLink>
                                                </Space>
                                            </Col>
                                        </Row>)
                                }
                            </Col>
                        </Row>
                    }
                />
            </div >
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${catalogueEditId !== '' ? 'Edit' : 'Add'} Catalogue`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component='form'
                        autoComplete='off'
                        onSubmit={(e) => createCatalogue(e)}
                    >
                        <div className={clsx(classes.customFormFlex)}>
                            {
                                commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.margin10t)} />
                            }
                            <TextField autoComplete='one-time-code'
                                label={["Catalogue Name ", <span key={"Catalogue Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorName ? true : false}
                                helperText={errorName}
                                name={"catalogueName"}
                                value={form.catalogueName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={["Catalogue Code"]}
                                name={"cataloguePrefix"}
                                value={form.cataloguePrefix}
                                variant={'standard'}
                                error={errorPrefix ? true : false}
                                helperText={errorPrefix}
                                className={clsx(classes.margin20t)}
                                rows={20}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => changeHandler(e)}
                            />

                            <div className={clsx(classes.productImageUpload, classes.addCatalogue)}>
                                <div className={classes.productImageUploadInner}>

                                </div>
                            </div>
                        </div>
                        <div className={clsx(classes.btnParent, classes.bold)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                    {
                                        catalogueEditId === '' ? 'Save & Close' : 'Update'
                                    }
                                </Button>
                                {
                                    catalogueEditId === '' &&
                                    <Button
                                        key="add"
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        onClick={(e) => handleAddMore(e)}>
                                        Add More
                                    </Button>
                                }
                            </Space>
                        </div>
                    </Box>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={viewVisible}
                variant={'temporary'}
                handleClose={() => handleViewClose()}
                title={`${categoryEditId !== '' ? 'Edit' : 'Add'} Category`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component='form'
                        autoComplete='off'
                        onSubmit={(e) => createCategory(e)}>
                        <div className={clsx(classes.customFormFlex)}>
                            {
                                commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.margin10t)} />
                            }
                            {
                                type === 'category' && <AutoCompleteComponent
                                    name={["Parent Category"]}
                                    disabled={true}
                                    heads={[{ 'key': 'categoryName', 'name': 'Name' },
                                    { 'key': 'categoryPrefix', 'name': 'Prefix' }]}
                                    details={categoryList}
                                    parentValue={customObject(categoryList, categoryForm.parentId)}
                                    onChange={(data) => catagoryChangeHandler(data, 'parentId')}
                                    position={"bottom"}
                                />
                            }
                            <AutoCompleteComponent
                                name={["Catalogue ", <span key={"Catalogue"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                                { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                                details={catalogueDetails}
                                parentValue={customObject(catalogueDetails, categoryForm.catalogueId)}
                                onChange={(data) => catagoryChangeHandler(data, 'catalogueId')}
                                parentError={errorCatalogueId}
                                position={"bottom"}
                                customClasses={clsx({ [classes.margin20t]: type === 'category' })}
                            />
                            <TextField autoComplete='one-time-code'
                                label={["Category Name ", <span key={"Category Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                className={clsx(classes.margin20t)}
                                name={"categoryName"}
                                shrink={true}
                                error={errorName ? true : false}
                                helperText={errorName}
                                value={categoryForm?.categoryName}
                                disabled={categoryForm.isBrand}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: categoryForm?.categoryName ? true : false,
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => catagoryChangeHandler(e)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={["Category Code"]}
                                variant={'standard'}
                                className={clsx(classes.margin20t)}
                                name={"categoryPrefix"}
                                error={errorPrefix ? true : false}
                                helperText={errorPrefix}
                                value={categoryForm.categoryPrefix}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => catagoryChangeHandler(e)}
                            />
                            <AutoCompleteComponent
                                name={["HSN Code"]}
                                heads={[{ 'key': 'hsnCode', 'name': 'HSN Code' },
                                { 'key': 'description', 'name': 'Description' }]}
                                details={hsnDetails}
                                searchType={(s) => hsnApi(s)}
                                parentValue={customObject(hsnDetails, categoryForm.hsnId)}
                                onChange={(data) => catagoryChangeHandler(data, 'hsnId')}
                                onChangeText={(value) => value === '' ? catagoryChangeHandler(value, 'hsnId') : ''}
                                position={"bottom"}
                                topPosition={true}
                                customClasses={classes.margin20t}
                            />
                            <AutoCompleteComponent
                                name={["Product GST Code"]}
                                heads={[{ 'key': 'code', 'name': 'Product GST Code' },
                                { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }]}
                                details={productGstdetails}
                                parentValue={customObject(productGstdetails, categoryForm.productGstId)}
                                onChangeText={(value) => value === '' ? catagoryChangeHandler(value, 'productGstId') : ''}
                                onChange={(data) => catagoryChangeHandler(data, 'productGstId')}
                                position={"bottom"}
                                topPosition={true}
                                customClasses={classes.margin20t}
                            />
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                }}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => setCategoryForm({ ...categoryForm, 'isBrand': !categoryForm.isBrand })}
                                />}
                                label="Is Brand"
                                labelPlacement="top"
                                checked={categoryForm.isBrand}
                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                            />
                            {
                                categoryForm.isBrand && <AutoCompleteComponent
                                    name={["Brands"]}
                                    heads={[{ 'key': 'brandName', 'name': 'Name' },
                                    { 'key': 'brandShortName', 'name': 'Short Name' }]}
                                    details={brandDetails}
                                    parentValue={customObject(brandDetails, categoryForm.brandId)}
                                    onChange={(data) => catagoryChangeHandler(data, 'brandId')}
                                    position={"top"}
                                    topPosition={true}
                                    parentError={errorBrand}
                                    customClasses={classes.margin20t}
                                />
                            }

                            <div className={clsx(classes.productImageUpload, classes.addCatalogue)}>
                                <div className={classes.productImageUploadInner}>
                                    <Upload
                                        maxCount={1}
                                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                        listType="picture"
                                    >
                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>Drag and Drop</Typography>
                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>or</Typography>
                                        <div className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>
                                            <Image
                                                src={ImportIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span></div>
                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>Product Image here</Typography>
                                        <Typography variant={'subtitle1'} paragraph={true} className={clsx(classes.textAreaLableColorUpload, classes.fonSize11)}>(Image size : Not to exceed 1 MB)</Typography>
                                    </Upload>
                                </div>
                            </div>

                        </div>
                        <div className={clsx(classes.btnParent, classes.bold)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                >
                                    {
                                        categoryEditId === '' ? 'Save & Close' : 'Update'
                                    }
                                </Button>
                                {
                                    categoryEditId === '' && <Button
                                        key="add"
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        onClick={(e) => handleAddMore(e)}
                                    >
                                        Add More
                                    </Button>
                                }
                            </Space>
                        </div>
                    </Box >
                }
            />
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'ProductCategories'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={catalogueDetails}
                loadTasks={() => { dispatchFilter() }}
            />
            <DeleteModal onClose={(v) => { setDeleteModal(v) }} id={commonData?.catalogueName ? catalogueEditId : categoryEditId}
                loadTasks={() => loadingNewData()}
                name={commonData?.catalogueName ? commonData?.catalogueName + ' catalogue' : commonData?.categoryName + ' category'}
                url={commonData?.catalogueName ? 'catalogues' : 'product-categories'}
                title={commonData?.catalogueName ? 'Catalogues' : 'Category'} visible={deleteModal} />
            <Modal
                title={'Delete Confirmation'}
                open={deleteAllModal}
                onOk={() => { setDeleteAllModal(false); }}
                onCancel={() => { setDeleteAllModal(false); }}
                width={525}
                className={clsx(classes.deletePopup, classes.deleteNotificationPopup)}
                // closeIcon={<CloseIcon />}
                footer={
                    [
                        <Button
                            key="yes"
                            type='submit'
                            color='primary'
                            variant="contained"
                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            onClick={() => handleDeleteIds()}
                        >Yes</Button>,
                        <Button
                            key="no"
                            type='submit'
                            color='primary'
                            variant="contained"
                            className={clsx(classes.AddMoreBtn)}
                            onClick={() => setDeleteAllModal(false)}
                        >
                            No
                        </Button>,
                    ]}>
                <p>The Selected Categories Including its Sub Categories and Products will be deleted, do You Want to Continue?</p>
                <p className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')}><Image className={clsx(classes.disInline, classes.verticalAlignMiddle)} src={infoMarkIcon} preview={false} /> <span className={clsx(classes.disInline, classes.verticalAlignMiddle, classes.fonSize13)}>Linked Products Will Not be Deleted.</span></p>
            </Modal>
        </React.Fragment>
    )
}

export default Catalogue;